import React from "react";
import PostsIndex from "./PostsIndex";

const Feed = () => {
  return (
    <div>
      <PostsIndex />
    </div>
  );
};

export default Feed;
